import { FilterOptionsState } from '@mui/material'

export const filterOptions = <T>(
  options: T[],
  state: FilterOptionsState<T>,
  targetKeys: (keyof T)[]
) => {
  const { inputValue } = state
  const rowerInput = inputValue.toLowerCase()

  return options.filter((v) => {
    if (!rowerInput) return true
    return targetKeys.some((key) => {
      const value = v[key] as string
      if (!value) return false
      return value.toLowerCase().includes(rowerInput)
    })
  })
}
